export default function WhitepaperSection() {
  return (
    <section id="whitepaper" className="relative py-32 bg-[#f4e8d0] overflow-hidden">
      {/* Torn edge effect at top */}
      <div className="absolute top-0 left-0 w-full h-8 bg-black">
        <svg className="absolute bottom-0 w-full h-8" preserveAspectRatio="none" viewBox="0 0 1200 20">
          <path d="M0,0 Q30,15 60,5 T120,10 T180,5 T240,15 T300,5 T360,10 T420,5 T480,15 T540,5 T600,10 T660,5 T720,15 T780,5 T840,10 T900,5 T960,15 T1020,5 T1080,10 T1140,5 L1200,0 L1200,20 L0,20 Z" fill="#f4e8d0"/>
        </svg>
      </div>

      {/* Aged paper texture */}
      <div className="absolute inset-0 opacity-20 bg-[url('https://public.readdy.ai/ai/img_res/1c83046b6ec69e6425962bc364d595f8.jpg')] bg-repeat" />

      {/* Corner ornaments */}
      <div className="absolute top-12 left-12 w-16 h-16 opacity-40">
        <img src="https://readdy.ai/api/search-image?query=norse%20celtic%20knotwork%20corner%20ornament%20design%20brown%20decorative%20border%20element%20viking%20pattern&width=200&height=200&seq=ornament-001&orientation=squarish" alt="Ornament" className="w-full h-full object-contain" />
      </div>
      <div className="absolute top-12 right-12 w-16 h-16 opacity-40 scale-x-[-1]">
        <img src="https://readdy.ai/api/search-image?query=norse%20celtic%20knotwork%20corner%20ornament%20design%20brown%20decorative%20border%20element%20viking%20pattern&width=200&height=200&seq=ornament-002&orientation=squarish" alt="Ornament" className="w-full h-full object-contain" />
      </div>
      <div className="absolute bottom-12 left-12 w-16 h-16 opacity-40 scale-y-[-1]">
        <img src="https://readdy.ai/api/search-image?query=norse%20celtic%20knotwork%20corner%20ornament%20design%20brown%20decorative%20border%20element%20viking%20pattern&width=200&height=200&seq=ornament-003&orientation=squarish" alt="Ornament" className="w-full h-full object-contain" />
      </div>
      <div className="absolute bottom-12 right-12 w-16 h-16 opacity-40 scale-[-1]">
        <img src="https://readdy.ai/api/search-image?query=norse%20celtic%20knotwork%20corner%20ornament%20design%20brown%20decorative%20border%20element%20viking%20pattern&width=200&height=200&seq=ornament-004&orientation=squarish" alt="Ornament" className="w-full h-full object-contain" />
      </div>

      {/* Wax seal stamps background */}
      {Array.from({ length: 5 }).map((_, i) => (
        <div
          key={i}
          className="absolute w-16 h-16 opacity-40"
          style={{
            left: `${20 + i * 15}%`,
            top: `${30 + (i % 2) * 40}%`
          }}
        >
          <img src={`https://readdy.ai/api/search-image?query=red%20wax%20seal%20stamp%20medieval%20ancient%20document%20authentication%20mark%20circular&width=200&height=200&seq=wax-seal-00${i}&orientation=squarish`} alt="Wax Seal" className="w-full h-full object-contain" />
        </div>
      ))}

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 items-start">
          {/* Left column - Scroll illustration */}
          <div className="lg:col-span-2 flex justify-center lg:sticky lg:top-32">
            <div className="relative animate-sway">
              <img
                src="https://readdy.ai/api/search-image?query=ancient%20scroll%20parchment%20partially%20unrolled%20runic%20text%20visible%20red%20wax%20seal%20with%20V%20symbol%203d%20render%20realistic%20detailed%20aged%20paper%20medieval%20document&width=600&height=800&seq=scroll-whitepaper-001&orientation=portrait"
                alt="Ancient Scroll"
                className="w-96 h-auto object-contain drop-shadow-2xl"
              />
            </div>
          </div>

          {/* Right column - Content */}
          <div className="lg:col-span-3">
            <h2 className="text-6xl lg:text-7xl font-bold text-[#3d2817] mb-8 leading-tight" style={{ fontFamily: 'Cinzel, serif' }}>
              VALHALLA TOKEN
            </h2>

            <p className="text-2xl font-bold text-[#d4af37] mb-8 italic" style={{ fontFamily: 'Cinzel, serif' }}>
              The Coin of the Gods
            </p>

            <p className="text-xl text-[#3d2817] font-semibold mb-12 italic">
              "Where warriors ascend, value rises eternally."
            </p>

            <div className="space-y-6 text-[#5a4a3a] text-lg leading-relaxed">
              <p>
                Valhalla Coin is a crypto forged in myth and built for glory — designed to reward loyalty, strengthen the community, and rise through every market cycle.
              </p>

              <p className="font-semibold text-[#3d2817]">
                When weak projects fall, Valhalla stands eternal.
              </p>

              <p>
                Driven by powerful tokenomics, fueled by unwavering holders, and supported by automatic buyback mechanics, Valhalla is engineered not just to survive — but to dominate.
              </p>

              {/* Why Valhalla */}
              <div className="mt-12 mb-8">
                <h3 className="text-3xl font-bold text-[#3d2817] mb-6 flex items-center gap-3" style={{ fontFamily: 'Cinzel, serif' }}>
                  <span className="text-[#d4af37]">🔥</span> Why Valhalla?
                </h3>

                <div className="space-y-6">
                  <div>
                    <h4 className="text-xl font-bold text-[#3d2817] mb-2 flex items-center gap-2">
                      <span className="text-[#d4af37]">⚔</span> Honor in Holding
                    </h4>
                    <p>True warriors are rewarded. Long-term holders benefit directly from continuous buyback pressure and sustainable token flow.</p>
                  </div>

                  <div>
                    <h4 className="text-xl font-bold text-[#3d2817] mb-2 flex items-center gap-2">
                      <span className="text-[#d4af37]">🔥</span> Constant Buy Demand
                    </h4>
                    <p>10% creator trading fee automatically goes to buybacks, increasing price support and compounding strength over time.</p>
                  </div>

                  <div>
                    <h4 className="text-xl font-bold text-[#3d2817] mb-2 flex items-center gap-2">
                      <span className="text-[#d4af37]">🏰</span> A Realm Built for Growth
                    </h4>
                    <p>Valhalla's economy scales through community, DeFi expansion, NFTs, staking and metaverse integration.</p>
                  </div>

                  <div>
                    <h4 className="text-xl font-bold text-[#3d2817] mb-2 flex items-center gap-2">
                      <span className="text-[#d4af37]">🌐</span> The Viking Army Expands
                    </h4>
                    <p>Marketing waves, collaborations, and global community growth push the Valhalla name across all of Web3.</p>
                  </div>
                </div>
              </div>

              {/* Transparent Tokenomics */}
              <div className="mt-12 mb-8 bg-black/10 rounded-2xl p-8 border-2 border-[#d4af37]">
                <h3 className="text-3xl font-bold text-[#3d2817] mb-6" style={{ fontFamily: 'Cinzel, serif' }}>
                  Transparent Tokenomics
                </h3>

                <div className="space-y-4">
                  <div className="flex justify-between items-center border-b border-[#d4af37]/30 pb-3">
                    <span className="font-semibold text-[#3d2817]">Token</span>
                    <span className="text-[#5a4a3a]">Valhalla (VAL)</span>
                  </div>
                  <div className="flex justify-between items-center border-b border-[#d4af37]/30 pb-3">
                    <span className="font-semibold text-[#3d2817]">Total Supply</span>
                    <span className="text-[#5a4a3a]">1,000,000,000 VAL</span>
                  </div>
                  <div className="flex justify-between items-center border-b border-[#d4af37]/30 pb-3">
                    <span className="font-semibold text-[#3d2817]">Creator Trading Fee</span>
                    <span className="text-[#5a4a3a]">10% directed to constant buybacks</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="font-semibold text-[#3d2817]">Goal</span>
                    <span className="text-[#5a4a3a]">Continuous buying pressure + long-term strength</span>
                  </div>
                </div>

                <p className="mt-6 text-center font-semibold text-[#3d2817] italic">
                  The buyback system ensures that every trade strengthens the ecosystem — Valhalla never falls, it only grows stronger.
                </p>
              </div>

              {/* Token Distribution */}
              <div className="mt-12 mb-8">
                <h3 className="text-3xl font-bold text-[#3d2817] mb-6" style={{ fontFamily: 'Cinzel, serif' }}>
                  Token Distribution
                </h3>

                <div className="bg-black/10 rounded-2xl p-6 border-2 border-[#d4af37]">
                  <div className="space-y-4">
                    <div className="flex justify-between items-center">
                      <div>
                        <div className="font-semibold text-[#3d2817]">Public Supply</div>
                        <div className="text-sm text-[#5a4a3a]">Open to the people — the true warriors</div>
                      </div>
                      <div className="text-2xl font-bold text-[#d4af37]">100%</div>
                    </div>
                    <div className="flex justify-between items-center pt-4 border-t border-[#d4af37]/30">
                      <div>
                        <div className="font-semibold text-[#3d2817]">Creator Trading Fee</div>
                        <div className="text-sm text-[#5a4a3a]">Fuels price support &amp; sustainability</div>
                      </div>
                      <div className="text-2xl font-bold text-[#d4af37]">10%</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Roadmap to Glory */}
              <div className="mt-12 mb-8">
                <h3 className="text-3xl font-bold text-[#3d2817] mb-6" style={{ fontFamily: 'Cinzel, serif' }}>
                  Roadmap to Glory
                </h3>

                <div className="space-y-6">
                  <div className="bg-black/10 rounded-xl p-6 border-l-4 border-[#d4af37]">
                    <h4 className="text-xl font-bold text-[#3d2817] mb-3">Phase I – Awakening (Current)</h4>
                    <ul className="space-y-2 text-[#5a4a3a]">
                      <li>• Launch of Valhalla Token</li>
                      <li>• Liquidity established</li>
                      <li>• Community presence forged</li>
                      <li>• Buyback mechanism activated 🚀</li>
                    </ul>
                  </div>

                  <div className="bg-black/10 rounded-xl p-6 border-l-4 border-[#d4af37]">
                    <h4 className="text-xl font-bold text-[#3d2817] mb-3">Phase II – Rise of the Army (Next)</h4>
                    <ul className="space-y-2 text-[#5a4a3a]">
                      <li>• Marketing expansion</li>
                      <li>• Social dominance + influencers</li>
                      <li>• Partnership quests begin</li>
                      <li>• First wave of warriors onboarded</li>
                    </ul>
                  </div>

                  <div className="bg-black/10 rounded-xl p-6 border-l-4 border-[#d4af37]">
                    <h4 className="text-xl font-bold text-[#3d2817] mb-3">Phase III – Expansion of the Realm</h4>
                    <ul className="space-y-2 text-[#5a4a3a]">
                      <li>• NFT Viking collection drop</li>
                      <li>• Staking &amp; rewards system</li>
                      <li>• Governance council opens (DAO)</li>
                      <li>• DeFi integration begins</li>
                    </ul>
                  </div>

                  <div className="bg-black/10 rounded-xl p-6 border-l-4 border-[#d4af37]">
                    <h4 className="text-xl font-bold text-[#3d2817] mb-3">Phase IV – Eternal Kingdom (Future)</h4>
                    <ul className="space-y-2 text-[#5a4a3a]">
                      <li>• Valhalla metaverse arena</li>
                      <li>• GameFi implementation</li>
                      <li>• Multi-chain expansion</li>
                      <li>• Full Valhalla Treasury governance</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Strengths */}
              <div className="mt-12 mb-8 bg-gradient-to-br from-[#d4af37]/20 to-transparent rounded-2xl p-8 border-2 border-[#d4af37]">
                <h3 className="text-3xl font-bold text-[#3d2817] mb-6" style={{ fontFamily: 'Cinzel, serif' }}>
                  Strengths of the Valhalla Ecosystem
                </h3>

                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <span className="text-2xl">🛡</span>
                    <div>
                      <span className="font-semibold text-[#3d2817]">Transparent Buyback Model</span>
                      <span className="text-[#5a4a3a]"> – constant market support</span>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="text-2xl">🏹</span>
                    <div>
                      <span className="font-semibold text-[#3d2817]">Community-Driven Decisions</span>
                      <span className="text-[#5a4a3a]"> – every holder is a warrior</span>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="text-2xl">🔥</span>
                    <div>
                      <span className="font-semibold text-[#3d2817]">Sustainable Growth Mechanics</span>
                      <span className="text-[#5a4a3a]"> – not hype, but strategy</span>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="text-2xl">🌍</span>
                    <div>
                      <span className="font-semibold text-[#3d2817]">Worldwide Expansion Potential</span>
                      <span className="text-[#5a4a3a]"> – built for scale</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Final Statement */}
              <div className="mt-12 text-center bg-black/20 rounded-2xl p-8 border-2 border-[#d4af37]">
                <p className="text-2xl font-bold text-[#3d2817] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>
                  Valhalla is not just a coin — it's a kingdom.
                </p>
                <p className="text-xl text-[#5a4a3a] italic">
                  Those who join do not merely invest — they ascend.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Ink splatter decorations */}
      <div className="absolute bottom-32 left-1/4 w-24 h-24 opacity-20">
        <img src="https://readdy.ai/api/search-image?query=brown%20ink%20splatter%20stain%20spot%20aged%20paper%20texture%20vintage%20effect&width=200&height=200&seq=ink-splatter-001&orientation=squarish" alt="Ink Splatter" className="w-full h-full object-contain" />
      </div>
    </section>
  );
}
